module.exports = __webpack_public_path__ + "img/send-message-dm.08eb8a5c.svg";